import React from 'react'
import { useTheme } from 'styled-components'
import { ContentCardProps } from './types'
import { Flex } from '../Flex'

const ContentCard = ({ children, ...props }: ContentCardProps) => {
  const theme = useTheme()

  return (
    <Flex px="24px" py="32px" background={theme.colors.backgroundContrast} {...props}>
      {children}
    </Flex>
  )
}

export default ContentCard
